<template>
  <v-card class="chartCardPdf mt-4" color="white">
    <h5
      style="border-top: 2px solid #000; border-bottom: 2px solid #fff; z-index:3; position:relative;"
      class="text-xs-left blue-grey--text text--darken-3 body-1 pl-1 pt-2 mb-0 pb-3"
    >{{docName.toUpperCase()}}</h5>
    <!-- font-weight-bold -->
    <!-- <div class="px-5 mx-5">

    </div>-->
    <!-- <v-card-text class="headline font-weight-bold"></v-card-text> -->

    <apexchart style="margin-top:-1px;" class type="donut" :options="chartOptions" :series="series"></apexchart>

    <v-card-actions class="pb-2 px-1" style="box-shadow: none; margin-top: auto;">
      <div class v-if="!expiredsDocs.length">Não há documentos vencidos</div>
      <div
        v-if="expiredsDocs.length"
        class="primary--text"
      >{{`${expiredsDocs.length} Documento${expiredsDocs.length > 1 ? 's' : ''} vencido${expiredsDocs.length > 1 ? 's' : ''}`}}</div>
      <!-- <v-expansion-panel v-if="!expiredsDocs.length" disabled>
        <v-expansion-panel-content>
          <template v-slot:header class="px-3">
            <div>Não há documentos vencidos</div>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="expiredsDocs.length" disabled>
        <v-expansion-panel-content>
          <template v-slot:header class="px-3">
            <div class="primary--text">{{expiredsDocs.length}} Documentos vencidos</div>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>-->
      <!-- <h4 v-if="!expiredsDocs.length" class="subheading">Não há documentos vencidos</h4> -->
      <!-- <v-expansion-panel v-if="expiredsDocs.length">
        <v-expansion-panel-content>
          <template v-slot:header class="px-3">

          </template>
          <v-card class="mxHeightScroll">
            <v-subheader
              v-for="(expiredDoc, i) in expiredsDocs"
              :key="i"
              :class="['pl-3 mb-1']"
              style="height: auto; font-size: 12px;"
            >• {{expiredDoc}}</v-subheader>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>-->
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  methods: {
    detailing () {
      // console.log(this.type_id)
      this.$store.commit('docsReports/updateDialogShow', true)
      this.$store.commit('docsReports/updateDocTypeSel', {
        docName: this.docName,
        status: '',
        type_id: this.type_id
      })
      // console.log(this.docName);
      this.$store.dispatch(
        'docsReports/getDocDetails' /*, {
        type_doc: this.docName,
        type_id: this.type_id,
        condominium_id: this.$store.state.docsReports.condominium_id
      } */
      )
    }
  },
  props: {
    type_id: Number,
    docName: String,
    series: Array,
    expiredsDocs: Array
  },
  data () {
    return {
      chartOptions: {
        stroke: {
          show: false
        },
        colors: ['#4caf50', '#ffab00', '#c62828', '#696A6D'],
        chart: {
          fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
          width: 100,
          type: 'donut',
          dropShadow: {
            enabled: false
          }
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              size: '55%'
            }
          }
        },
        labels: ['Vigentes', 'A vencer', 'Vencidos', 'Em obtenção'],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return `${val.toFixed(0)}%`
          },
        },
        fill: {
          colors: ['#4caf50', '#ffab00', '#c62828', '#696A6D']
        },
        legend: {
          show: false,
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 4,
            opacity: 1
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 100
              },
              legend: {
                show: false
              }
            }
          }
        ]
      }
    }
  }
}
</script>

<style>
.mxHeightScroll {
  max-height: 180px !important;
  overflow-y: auto;
  padding-bottom: 5px;
}
.chartCardPdf {
  display: flex;
  flex-direction: column;
  min-height: 310px;
  border-bottom: 4px solid #000 !important;
}
.chartCardPdf .v-expansion-panel__header {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.chartCardPdf ul.v-expansion-panel {
  border-bottom: 4px solid #000;
  box-shadow: none !important;
}
button.detailsDocs {
  z-index: 2 !important;
}
</style>
